const REQUEST_ID_PATTERN = /^[a-zA-Z0-9_-]{1,64}$/;
let _injectedRandomSource;
/**
 * Injects a deterministic or environment-specific random source. Intended for
 * tests and environments that provide their own secure generator. Production
 * callers should leave this unset and rely on `globalThis.crypto.getRandomValues`.
 */
export function injectRequestIdRandomSource(source) {
    _injectedRandomSource = source;
}
function getRandomBytes(size) {
    const source = _injectedRandomSource ??
        (typeof globalThis.crypto !== "undefined"
            ? ((n) => globalThis.crypto.getRandomValues(new Uint8Array(n)))
            : undefined);
    if (!source) {
        throw new Error("Secure random source unavailable: request ID generation requires crypto.getRandomValues or an injected random source.");
    }
    return source(size);
}
export function generateRequestId() {
    return Array.from(getRandomBytes(16))
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
}
export function isValidRequestId(value) {
    return typeof value === "string" && REQUEST_ID_PATTERN.test(value);
}
export function sanitizeRequestId(value) {
    if (isValidRequestId(value))
        return value;
    return undefined;
}
//# sourceMappingURL=requestId.js.map